import { createReducer, on } from '@ngrx/store';
import { driverLicenseActions } from '../driver_license.actions';

export interface DlDeleteExtractionState {
    state: 'pending' | 'loading' | 'loaded' | 'error';
}

export const initialState: DlDeleteExtractionState = { state: 'pending' };

export const dlDeleteExtractionReducer = createReducer(
    initialState,
    on(driverLicenseActions.deleteExtraction, (state) => ({ ...state, state: 'loading' as const })),
    on(driverLicenseActions.deleteExtractionSuccess, (state) => ({ ...state, state: 'loaded' as const })),
    on(driverLicenseActions.deleteExtractionFail, (state) => ({ ...state, state: 'error' as const })),
    on(driverLicenseActions.clearDeleteExtraction, () => initialState)
);
